import { Suspense, lazy } from 'react'

import { Hero, Footer, Header } from 'components/index'
import { WhyUs } from 'components/organisms/WhyUs/WhyUs'
import { Commission } from 'components/organisms/Commission/Commission'
import { Testimonials } from 'components/organisms/Testimonials/Testimonials'
import { FAQ } from 'components/organisms/FAQ/FAQ'
import { Contacts } from 'components/organisms/Contacts/Contacts'
import type { PageData } from 'lib/types/pageData'
import { SECTIONS } from 'lib/config/sections'
import { FormsProvider } from 'lib/contexts/FormsContext'
import { useStagProcessor } from 'lib/hooks/useStagProcessor'

const ModalsWrapper = lazy(() =>
  import('components/organisms/modals/ModalsWrapper').then((module) => ({
    default: module.ModalsWrapper,
  }))
)

const menu = SECTIONS.map(({ key, anchor }) => ({
  href: anchor,
  text: key,
}))

type AppProps = {
  data: PageData
}

export const App = ({ data }: AppProps) => {
  const modals = data.modals || {}
  useStagProcessor()

  return (
    <FormsProvider>
      <Header menu={menu} />
      <main role="main">
        {data.hero && <Hero {...data.hero} />}
        {data.whyUs && <WhyUs {...data.whyUs} />}
        {data.commission && <Commission {...data.commission} />}
        {data.testimonials && <Testimonials {...data.testimonials} />}
        {data.faq && <FAQ {...data.faq} />}
        {data.contacts && <Contacts {...data.contacts} />}
      </main>
      {data.footer && <Footer {...data.footer} />}

      {/* Only modals are lazy - they're hidden initially, no CLS impact */}
      <Suspense fallback={null}>
        <ModalsWrapper
          modalProps={{
            login: modals.login || {},
            signup: modals.signUp || {},
            reset: modals.reset || {},
            terms: modals.terms || {},
            notVerified: modals.notVerified || {},
          }}
        />
      </Suspense>
    </FormsProvider>
  )
}
